// extracted by mini-css-extract-plugin
export default {"root":"root--c32i_","content":"content--SFbH8","caption":"caption--mnG6q","description":"description--qy3Eg","action":"action--MALO1","icon":"icon--aH97D"};